import { Component, Input } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { MenuStateService } from '../../../services/menu-state.service';
import { first, Subscription } from 'rxjs';

@Component({
  selector: 'app-mobile-modelos',
  standalone: false,
  templateUrl: './mobile-modelos.component.html',
  styleUrl: './mobile-modelos.component.css'
})
export class MobileModelosComponent {
  @Input() categoria:any;
  modelos: any[]=[];

  constructor(private dataService: DataService, private menuStateService: MenuStateService) {
    
  }

  ngOnInit(): void {
    const modelosGuardados = localStorage.getItem(this.categoria);
    
    if (modelosGuardados) {
      this.modelos = JSON.parse(modelosGuardados);
    }
  }

  // Notificar que el menú debe cerrarse
  cerrarMenu(): void {
    this.menuStateService.toggleMenu(false);
  }
  formatKey(key: string): string {
    return key
      .replace(/-/g, ' '); // capitaliza cada palabra
  }
}